<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        Push Notification
      </div>
      <div class="page__header-tools">
        <b-row>
          <b-col>
            <b-button size="sm" variant="success" @click="addNotification">
              <i class="icon-upload3 icon"></i> New Notification
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <hr />
    <div class=" border-0">
      <div class="card-body px-0 rounded overflow-auto">
        <div class="b2b-table">
          <b-table class="reporting-table" hover :items="rows">
          </b-table>
        </div>

        <!-- Pagination -->
        <div class="pagination">
          <Multiselect :options="pageSizeArray" v-model="pageSize" class="pageSizeMS" />
          <b-pagination v-model="page" :total-rows="totalRecords" :per-page="pageSize" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import API from "../api.js"

export default {
  data: function () {
    return {
      rows: [],
      page: 1,
      totalRecords: 0,
      pageSize: 10,
      pageSizeArray: [10, 20, 50, 100],
    };
  },
  watch: {
    page() {
      this.paginationTable();
    },

  },

  async mounted() {
    let dataOfNotification = await API.loadNotification();
    this.totalRecords = dataOfNotification.data.allnotification.count
      this.rows = dataOfNotification.data.allnotification.allRecords;
  },

  methods: {
    async paginationTable() {
      const obj = {
        page: this.page,
        pageSize: this.pageSize
      }
      let dataOfNotification = await API.loadNotification(obj);
      console.log()
      this.totalRecords = dataOfNotification.data.allnotification.count
      this.rows = dataOfNotification.data.allnotification.allRecords;
    },
    addNotification() {
      this.$router.push("notification/add");
    },
  },
};
</script>